import ModalInput from "./ModalInput";

export default ModalInput;
